module.exports = __webpack_public_path__ + "assets/img/27_1287_big.83d9271f.jpg";